import { c } from '../../contract';
import { adjustRouter } from './adjust-events.router';

export const webhooksRouter = c.router(
  {
    adjust: adjustRouter,
  },
  { pathPrefix: '/webhooks' },
);
